/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderFlagDTOFromJSON, OrderFlagDTOToJSON, } from './OrderFlagDTO';
/**
 * @export
 */
export const OrderTrackingItemDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const OrderTrackingItemDTODispatchModeEnum = {
    Ship: 'SHIP',
    Hold: 'HOLD',
    NotComing: 'NOT_COMING'
};
/**
 * @export
 */
export const OrderTrackingItemDTOTrackingCheckStatusEnum = {
    NoTracking: 'NO_TRACKING',
    Match: 'MATCH',
    Mismatch: 'MISMATCH'
};
/**
 * @export
 */
export const OrderTrackingItemDTOSupplierDeliveryAlertEnum = {
    None: 'NONE',
    DueToday: 'DUE_TODAY',
    Delayed: 'DELAYED',
    AwaitingWarehouseReceipt: 'AWAITING_WAREHOUSE_RECEIPT',
    NotArriving: 'NOT_ARRIVING',
    BuyerOrderCancelled: 'BUYER_ORDER_CANCELLED',
    StatusUnknown: 'STATUS_UNKNOWN',
    NotChecked: 'NOT_CHECKED'
};
/**
 * @export
 */
export const OrderTrackingItemDTOOrderStatusEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * Check if a given object implements the OrderTrackingItemDTO interface.
 */
export function instanceOfOrderTrackingItemDTO(value) {
    return true;
}
export function OrderTrackingItemDTOFromJSON(json) {
    return OrderTrackingItemDTOFromJSONTyped(json, false);
}
export function OrderTrackingItemDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'warehouse': json['warehouse'] == null ? undefined : json['warehouse'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'carrierService': json['carrierService'] == null ? undefined : json['carrierService'],
        'purchaseCostUsd': json['purchaseCostUsd'] == null ? undefined : json['purchaseCostUsd'],
        'saleAmount': json['saleAmount'] == null ? undefined : json['saleAmount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'shipByDate': json['shipByDate'] == null ? undefined : (new Date(json['shipByDate'])),
        'deliverByDate': json['deliverByDate'] == null ? undefined : (new Date(json['deliverByDate'])),
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'dispatchMode': json['dispatchMode'] == null ? undefined : json['dispatchMode'],
        'trackingCheckStatus': json['trackingCheckStatus'] == null ? undefined : json['trackingCheckStatus'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'supplierDeliveryAlert': json['supplierDeliveryAlert'] == null ? undefined : json['supplierDeliveryAlert'],
        'flag': json['flag'] == null ? undefined : OrderFlagDTOFromJSON(json['flag']),
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'itemCount': json['itemCount'] == null ? undefined : json['itemCount'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'cancelledBy': json['cancelledBy'] == null ? undefined : json['cancelledBy'],
        'cancellationRequestedBy': json['cancellationRequestedBy'] == null ? undefined : json['cancellationRequestedBy'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
    };
}
export function OrderTrackingItemDTOToJSON(json) {
    return OrderTrackingItemDTOToJSONTyped(json, false);
}
export function OrderTrackingItemDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'amazonOrderId': value['amazonOrderId'],
        'warehouse': value['warehouse'],
        'carrierName': value['carrierName'],
        'carrierService': value['carrierService'],
        'purchaseCostUsd': value['purchaseCostUsd'],
        'saleAmount': value['saleAmount'],
        'currencyCode': value['currencyCode'],
        'purchaseDate': value['purchaseDate'] == null ? undefined : ((value['purchaseDate']).toISOString()),
        'shipByDate': value['shipByDate'] == null ? undefined : ((value['shipByDate']).toISOString()),
        'deliverByDate': value['deliverByDate'] == null ? undefined : ((value['deliverByDate']).toISOString()),
        'packageStatus': value['packageStatus'],
        'dispatchMode': value['dispatchMode'],
        'trackingCheckStatus': value['trackingCheckStatus'],
        'trackingNumber': value['trackingNumber'],
        'supplierDeliveryAlert': value['supplierDeliveryAlert'],
        'flag': OrderFlagDTOToJSON(value['flag']),
        'imageUrl': value['imageUrl'],
        'itemCount': value['itemCount'],
        'orderStatus': value['orderStatus'],
        'cancelledBy': value['cancelledBy'],
        'cancellationRequestedBy': value['cancellationRequestedBy'],
        'cancellationReason': value['cancellationReason'],
    };
}
